module.exports = __webpack_public_path__ + "img/maintop.ce3dbe4.png";